import React, { useState } from "react";
import classnames from "classnames";

import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//utils
import { DivideByKeyResultTypes } from "../../../utils";

// interfaaces
import { ContactTypes } from "../../../data/contacts";
import AssignModal from "./AssignModal";

interface ContactItemProps {
  contact: ContactTypes;
  onSelectChat: (contact: object | number, isChannel?: boolean) => void;
}
const ContactItem = ({ contact, onSelectChat }: ContactItemProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [openModal, setopenModal] = useState(false);

  const toggle = () => setDropdownOpen(!dropdownOpen);

  const fullName = `${contact.firstName} ${contact.lastName}`;
  const shortName = `${contact?.firstName?.charAt(0) ?? ''}${contact?.lastName?.charAt(0) ?? ''}`;

  const colors = [
    "bg-primary",
    "bg-danger",
    "bg-info",
    "bg-warning",
    "bg-secondary",
    "bg-pink",
    "bg-purple",
  ];
  const [color] = useState(Math.floor(Math.random() * colors.length));

  return (
    <li onClick={() => onSelectChat({ ...contact, type: 'user' })}>
      <div className="d-flex align-items-center">
        <div className="flex-shrink-0 me-2">
          <div className="avatar-xs">
            {contact.profileImage ? (
              <img
                src={contact.profileImage}
                alt=""
                className="img-fluid rounded-circle"
              />
            ) : (
              <span
                className={classnames(
                  "avatar-title",
                  "rounded-circle",
                  "font-size-10",
                  "text-uppercase",
                  colors[color]
                )}
              >
                {shortName}
              </span>
            )}
          </div>
        </div>
        <div className="flex-grow-1">
          <h5 className="font-size-14 m-0">{fullName}</h5>
        </div>
        <div className="flex-shrink-0">
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle tag="a" className="text-mute">
              <i className="bx bx-dots-vertical-rounded align-middle"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                onClick={() => setopenModal(true)}
                className="d-flex align-items-center justify-content-between"
              >
                Assign <i className="bx bx-user ms-2 text-muted"></i>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <AssignModal isOpen={openModal} onClose={() => setopenModal(false)} contact={contact} />
        </div>
      </div>
    </li>
  );
};
interface CharacterItemProps {
  letterContacts: ContactTypes;
  index: number;
  onSelectChat: (contact: object | number, isChannel?: boolean) => void;
}
const CharacterItem = ({
  letterContacts,
  index,
  onSelectChat,
}: CharacterItemProps) => {
  return (
    <div className="mt-3">
      <div className={classnames({ "mt-3": index !== 0 })}>
        {/* <div className="contact-list-title">{letterContacts.letter}</div> */}

        <ul className="list-unstyled contact-list">
          {/* {(letterContacts.data || []).map((contact: any, key: number) => ( */}
          <ContactItem
            contact={letterContacts}
            // key={key}
            onSelectChat={onSelectChat}
          />
          {/* ))} */}
        </ul>
      </div>
    </div>
  );
};

export default CharacterItem;
